import DoctorSignature, { DoctorSignatureFooter, SIGNATURE_FOOTER_SPACE } from "./DoctorSignature";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { drName } from "../redux/apiUrl";
// import { base64logo, base64watermark } from "./BaseImages";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

// Definir los estilos
const styles = StyleSheet.create({
  page: {
    // color: "#454546",
    // height: "100%",
    // margin: 20,
    padding: 0,
    // color: "#333",
    paddingBottom: SIGNATURE_FOOTER_SPACE,
    fontSize: 12,
    color: "#000",
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 40,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "Roboto",
    color: "#000",
    marginBottom: 20,
  },
  companyInfo: {
    textAlign: "center",
    paddingHorizontal: 40,
    marginBottom: 20,
    fontSize: 10,
  },
  textBold: {
    color: "#000",
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: 700,
    width: "48%", // two items per row, with some space between
  },

  logo: {
    width: "100%",
    height: "15%",
  },
  headerright: {
    width: "auto",
    height: "40%", // Último valor definido
  },
  section: {
    paddingHorizontal: 10,
    marginBottom: 10,
  },

  text: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "Roboto",
  },
  footerImage: {
    width: "100%",
    height: "8%",
    position: "absolute",
    bottom: 0,
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.1,
    zIndex: "-10",
  },
  gridContainer: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 50,
    marginBottom: 20,
    fontSize: 12,
  },

  gridContainerTotal: {
    // width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 50,
    marginBottom: 20,
    fontSize: 12,
  },

  gridItemTitle: {
    width: "48%", // two items per row, with some space between
    paddingBottom: 5,
    fontSize: 12,
    fontFamily: "Roboto",
    fontWeight: 1000,
    // borderBottom: "1px solid #000",
    // borderTop: "1px solid #000",
    // borderLeft: "1px solid #000",
    // borderRight: "1px solid #000",
  },
  gridItem: {
    width: "48%", // two items per row, with some space between
    marginBottom: 5,
    fontSize: 12,
  },
  singleItem: {
    width: "100%",
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  firmas: {
    marginTop: 40,
    width: "100%",
    paddingHorizontal: 30,
    display: "flex",
    flexDirection: "row",
    gap: 20,
    position: "absolute",
    bottom: 20,
  },
  colum: {
    flex: 1,
    marginRight: 20,
    textAlign: "center",
    paddingTop: 125,
  },
});

const PaymentPdf = ({ data }) => {
  return (
    <Document>
      <Page style={styles.page}>
        <Image style={styles.watermark} src="/images/longLogo.png" />
        <Image style={styles.logo} src="/images/headerright.png" />
        {/* Title */}
        <Text style={styles.title}>RECIBO PAGO</Text>
        {/* Company Information */}
        <View style={styles.companyInfo}>
          <Text>Consultorio {drName}</Text>
          {/* <Text >Calle Venezuela #355 casi Av. Bush</Text>
          <Text >Telefono: (591) 72165797</Text> */}
        </View>

        {/* Patient Information */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Fecha:</Text> {data?.fecha}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Telefono:</Text> {data?.telefono}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Recibi de:</Text> {data?.nombre}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Metodo de pago:</Text>{" "}
              {data?.metodo}
            </Text>
          </View>
        </View>

        {/* Receta Details */}
        <View style={styles.section}>
          <View style={styles.gridContainer}>
            <Text style={styles.gridItemTitle}>Descripcion</Text>
            <Text style={styles.gridItemTitle}>Monto</Text>
          </View>
          <View style={styles.gridContainer}>
            <Text style={styles.gridItem}>{data?.motivo}</Text>
            <Text style={styles.gridItem}>Bs. {data?.monto}</Text>
          </View>
        </View>

        {/* Total */}
        <View style={styles.gridContainerTotal}>
          <Text style={styles.text}>
            <Text style={styles.textBold}>Total en letras:</Text>{" "}
            {data?.monto_literal}
          </Text>
          <Text style={styles.text}>
            <Text style={styles.textBold}>Total:</Text> Bs. {data?.monto}
          </Text>
        </View>
        <View style={styles.gridContainerTotal}>
          <Text style={styles.text}>
            <Text style={styles.textBold}></Text>
          </Text>
          <Text style={styles.text}>
            <Text style={styles.textBold}>Saldo:</Text> Bs. {data?.saldo}
          </Text>
        </View>

        {/* Firmas */}
        <DoctorSignatureFooter>
          <DoctorSignature doctor={data?.doctor} />
          <View style={styles.colum}>
            <Text style={styles.text}>______________________</Text>
            <Text style={styles.text}>Entregue Conforme</Text>
          </View>
        </DoctorSignatureFooter>

        {/* Footer */}
        {/* <Image style={styles.footerImage} src="/images/footerImage.png" /> */}
      </Page>
    </Document>
  );
};

export default PaymentPdf;
